import { SFTPAPI } from '@core/typings/api/sftp.typing';
import { TypeaheadSelectOption } from '@yourcause/common/core-forms';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class SFTPState extends BaseYcState {
  readonly basicCredentialsList: SFTPAPI.BasicSFTPCredentials[];
  readonly userCredentialsList: TypeaheadSelectOption<number>[];
  readonly userCredentials: SFTPAPI.UserSFTPCredentials[];
}
